(() => $('body').data('automation-login-hook', true))();
